import { render, staticRenderFns } from "./selfDeclarationForm.vue?vue&type=template&id=82881a0e&scoped=true"
import script from "./selfDeclarationForm.vue?vue&type=script&lang=js"
export * from "./selfDeclarationForm.vue?vue&type=script&lang=js"
import style0 from "./selfDeclarationForm.vue?vue&type=style&index=0&id=82881a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82881a0e",
  null
  
)

export default component.exports